module.exports = __webpack_public_path__ + "static/media/add-img.9641bdde.svg";